import moment from 'moment';

const getDueIn = (endDate: string | number, displayShort = true): string => {
  const now = moment();
  const duration = moment.duration(moment(endDate).diff(now));

  const dueInDays = Math.floor(duration.asDays());
  const dueInHours = duration.hours();
  const dueInMinutes = duration.minutes();

  if (duration.asMilliseconds() <= 0) return '---';

  if (dueInDays < 1 && dueInHours < 1) return `${dueInMinutes}m`;

  if (dueInDays < 1) return `${dueInHours}h ${dueInMinutes}m`;

  return displayShort ? `${dueInDays}d ${dueInHours}h` : `${dueInDays}D ${dueInHours}H`;
};

export default getDueIn;
